import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import VueScroll from "vuescroll";
import SplitPanel from "@/components/SplitPanel";
import { CodeEditor } from "../CodeEditor";
import { CodeCopyLeft } from "../CodeCopyLeft";
import { State } from "vuex-class";
import { LikeOrNot } from "../LikeOrNot/index";

@Component({
    components: {
        VueScroll,
        SplitPanel,
        CodeEditor,
        CodeCopyLeft,
        LikeOrNot
    }
})
export default class CodeCopyItem extends Vue {
    @Prop() readonly item!: any;
    @Prop() readonly section!: any;
    private offset: number = 0.38;
    @State("study") studyState: object;
    @Prop() readonly teacherAvatar: string;

    @Emit()
    handleJumpClick() {}
}

//@ts-ignore
export { default as CodeCopyItem } from "./index.vue";
